export default {
    INTERNAL: 'internal',
    EXTERNAL: 'external'
};